export default {
  "consentSection": "Enable & consent",
  "linksSection": "Linked channels",
  "catalogSection": "Available commands",
  "aliasesSection": "Command aliases",
  "verified": "Verified",
  "pending": "Pending",
  "revoked": "Revoked",
  "disconnectAccount": "Disconnect this account",
  "disconnectLabel": "Disconnect {{provider}} {{sender}}",
  "disconnectDescription": "This removes your linked {{provider}} account ({{sender}}) and stops all command hooks for it. You'll need to re-link to use commands again.",
  "disconnect": "Disconnect",
  "disconnected": "Channel disconnected",
  "disconnectFailed": "Could not disconnect.",
  "aliasFor": "Create an alias for {{verb}}",
  "selected": "Selected",
  "alias": "Alias",
  "channelTitle": "Command Channel",
  "channelDescription": "Operate your apps from a linked chat channel.",
  "disabled": "The command channel is not enabled on this install. Ask an administrator to turn it on.",
  "retry": "Retry",
  "consentDescription": "Let yourself operate this install by messaging the QBxBot. Off until you opt in.",
  "enable": "Enable my command channel",
  "enableDescription": "When on, verified channels you've linked can run commands on your behalf. Turn off any time to pause all your inbound commands.",
  "consentFailed": "Could not update consent.",
  "linksTitle": "Linked Channels",
  "linksDescription": "Prove you own a chat account before it can send commands. Each link is bound to your account.",
  "linkChannel": "Link channel",
  "noProviders": "No chat providers are enabled on this install yet. Ask an administrator to enable Discord or Signal comms.",
  "optInFirst": "Opt in above to link a channel.",
  "noLinks": "No channels linked yet.",
  "adminAuthority": "Commands run as you, on your own apps. As an administrator, you can also run admin-scoped commands.",
  "selfAuthority": "Commands run as you and only ever touch your own apps.",
  "discordInstructions": "Once your Discord account is linked, send the bot a direct message to run a command — the bot also DMs you any alerts you've opted into.",
  "messageDocs": "How to message the bot",
  "catalogTitle": "Available Commands",
  "catalogDescription": "The commands you can run on this install. Pick one to start an alias for it.",
  "collapse": "Collapse",
  "expand": "Expand",
  "noCommands": "No commands are available to you yet.",
  "aliasesTitle": "Command Aliases",
  "aliasesDescription": "Name shortcuts that map to the commands you're allowed to run.",
  "usernameHint": "A username",
  "appHint": "An app id",
  "integerHint": "A whole number",
  "durationHint": "A duration (e.g. seconds)",
  "enumHint": "A preset value",
  "textHint": "A short text value",
  "unknownType": "Type: {{kind}}",
  "selectApp": "Select an app…",
  "noApps": "No apps available",
  "required": "Required",
  "optional": "Optional",
  "selectCommand": "Select a command…",
  "aliasSaved": "Alias saved",
  "aliasSaveFailed": "Could not save alias.",
  "aliasRemoved": "Alias removed",
  "aliasRemoveFailed": "Could not remove alias.",
  "linkFirst": "Link and verify a channel above to create command aliases.",
  "exposeFirst": "No commands are available to you yet. Ask an administrator to expose commands for this install.",
  "aliasName": "Alias name",
  "aliasNameHint": "What you'll type to run it (e.g. killplex).",
  "command": "Command",
  "confirmationHint": "When run, this command will ask you to confirm in the channel before it executes.",
  "requiresConfirmation": "requires confirmation on use",
  "clear": "Clear",
  "addAlias": "Add alias",
  "removeAlias": "Remove this alias",
  "removeAliasLabel": "Remove alias {{alias}}",
  "targetHint": "This alias runs against this user's apps.",
  "params": "Params",
  "noParams": "No parameters",
  "linkTitle": "Link a command channel",
  "linkPick": "Pick a channel to link to your account",
  "linkFinishDiscord": "DM the code to your QBxBot to finish",
  "linkFinishSignal": "Message the code to your QBxBot to finish",
  "linked": "Linked",
  "close": "Close",
  "channel": "Channel",
  "linkAuthority": "This link is bound to your account. Commands you send run as you, on your own apps — what you can run depends on your role.",
  "cancel": "Cancel",
  "getCode": "Get linking code",
  "sendCodeDiscord": "DM this code to your QBxBot from the Discord account you want to command from. We'll confirm automatically once the bot receives it.",
  "sendCodeSignal": "Message this code to your QBxBot from the Signal account you want to command from. We'll confirm automatically once the bot receives it.",
  "copyCode": "Copy code",
  "waitingDiscord": "Waiting for your DM…",
  "waitingSignal": "Waiting for your message…",
  "expired": "This code expired. Start over to get a new one.",
  "startOver": "Start over",
  "checkNow": "Check now",
  "linkDone": "Channel linked. You can now send commands from that account.",
  "done": "Done",
  "channelLinked": "Channel linked",
  "notLinkedDiscord": "Not linked yet — DM the bot the code from your Discord account, then check again.",
  "notLinkedSignal": "Not linked yet — message the bot the code from your Signal account, then check again.",
  "checkFailed": "Couldn't check link status. Try again.",
  "copyFailed": "Could not copy the code.",
  "linkFailed": "Could not start linking.",
  "unavailable": "Unavailable",
  "unavailableHint": "Unavailable on this install.",
  "mutationHint": "Destructive admin action — runs a state-changing operation on this install. Expose with care.",
  "mutation": "mutation",
  "writeHint": "Changes state on this install (needs a write-scoped key).",
  "readHint": "Read-only — reports state without changing anything.",
  "mutates": "mutates",
  "readOnly": "read-only",
  "adminHint": "Only administrators can run this command.",
  "selfHint": "Any opted-in user can run this on their own apps.",
  "roleAdmin": "admin",
  "roleSelf": "self",
  "echoHint": "Stronger confirm: the admin must reply {{confirmation}} — echoing the target back, not just the code — so a single stray reply can't complete it.",
  "confirmHint": "Requires a confirmation reply before this command runs.",
  "noConfirmHint": "Runs immediately — no confirmation reply needed.",
  "confirmEcho": "confirm + echo",
  "confirm": "confirm",
  "noConfirm": "no confirm",
  "manageLabel": "Manage {{title}} on the dashboard",
  "manage": "Manage",
  "catalogHelp": "Each command runs one specific, pre-defined action over a linked chat channel — never free-form input. The badges show who may run it, whether it changes state, and whether it needs a confirmation reply.",
  "learnMore": "Learn more",
  "catalogEmpty": "No commands are defined in the catalog.",
  "crossAliases": "Cross-User Command Aliases",
  "crossDescription": "Build aliases that run commands against another user's apps.",
  "crossFullDescription": "Build aliases that run commands against another user's apps. The command runs as you, targeting the user you select.",
  "crossCatalogDescription": "The commands you can run on this install. Pick one to start a cross-user alias for it.",
  "selectUser": "Select a user…",
  "selectTarget": "Select a target user first",
  "loadingApps": "Loading apps…",
  "noSharedApps": "No shared apps with this user",
  "targetUser": "Target user",
  "noUsers": "No users on this install",
  "targetDescription": "Commands will run against this user's apps.",
  "crossAuthority": "Cross-user aliases run as you. The target must have the app installed — only shared apps appear in the picker.",
  "loadFailed": "Failed to load command channel.",
  "hooksFailed": "Failed to load aliases.",
  "usersFailed": "Failed to load target users.",
  "appsFailed": "Failed to load apps.",
  "unauthorized": "Sign in again to use commands.",
  "invalidOptIn": "Invalid consent request.",
  "invalidLink": "Invalid link request.",
  "invalidStatus": "Invalid status request.",
  "invalidProvider": "Invalid provider.",
  "invalidHook": "Invalid alias request.",
  "unknownVerb": "Unknown command.",
  "notAuthorized": "Not authorized for that command.",
  "aliasConflict": "You already have an alias with that name.",
  "invalidHookId": "Invalid alias ID.",
  "hookNotFound": "Alias not found.",
  "no_installed_apps": "No apps are installed.",
  "no_download_client": "No download client is installed.",
  "vpn_not_configured": "VPN is not configured.",
  "fail2ban_not_installed": "Fail2Ban is not installed.",
  "service_statusTitle": "Service Status",
  "service_statusDescription": "Show the current running state of one installed app's service.",
  "service_startTitle": "Start Service",
  "service_startDescription": "Start the service for one installed app.",
  "service_stopTitle": "Stop Service",
  "service_stopDescription": "Stop the service for one installed app.",
  "service_restartTitle": "Restart Service",
  "service_restartDescription": "Restart the service for one installed app.",
  "service_status_allTitle": "All Service Statuses",
  "service_status_allDescription": "List the running state of every app installed for you.",
  "disk_usageTitle": "Disk Usage",
  "disk_usageDescription": "Show your current disk usage against your allowance.",
  "vpn_statusTitle": "VPN Status",
  "vpn_statusDescription": "Show your OpenVPN provisioning and per-app routing status.",
  "download_statusTitle": "Download Activity",
  "download_statusDescription": "Show active download counts across your download clients.",
  "system_telemetryTitle": "System Telemetry",
  "system_telemetryDescription": "Show the server's current CPU, memory, and disk utilization.",
  "system_app_statusTitle": "System App Status",
  "system_app_statusDescription": "List which system-wide apps are installed on the server.",
  "system_db_healthTitle": "Database Health",
  "system_db_healthDescription": "Show the database provider, health, version, and size.",
  "user_statusTitle": "User Status",
  "user_statusDescription": "Show one user's account status, level, apps, sessions, and security factors.",
  "fail2ban_statusTitle": "Fail2Ban Status",
  "fail2ban_statusDescription": "Show whether Fail2Ban is running and how many IPs are banned.",
  "quota_statusTitle": "Storage Quota Status",
  "quota_statusDescription": "Show the instance's total storage allowance, consumption, and media-asset usage.",
  "update_checkTitle": "Check for Updates",
  "update_checkDescription": "Show available updates for apps, QuickBox, the dashboard, and Signal.",
  "user_banTitle": "Ban User",
  "user_banDescription": "Ban a user account and run the ban enforcement on the server.",
  "user_unbanTitle": "Unban User",
  "user_unbanDescription": "Lift a ban and restore a user's account access.",
  "user_createTitle": "Create User",
  "user_createDescription": "Create a user account and email them an activation link to set their password.",
  "fail2ban_unbanTitle": "Unban IP",
  "fail2ban_unbanDescription": "Remove an IP address from all Fail2Ban jails.",
  "backup_triggerTitle": "Trigger Backup",
  "backup_triggerDescription": "Start a backup job of the selected type (database, config, or full).",
  "app_updateTitle": "Update App",
  "app_updateDescription": "Update one installed app to the latest version for its channel.",
  "quota_enableTitle": "Enable Quota Reservation",
  "quota_enableDescription": "Switch the storage quota policy to pre-allocated (reserves space upfront).",
  "quota_disableTitle": "Disable Quota Reservation",
  "quota_disableDescription": "Switch the storage quota policy to first-come (no upfront reservation).",
  "quota_setTitle": "Set User Quota",
  "quota_setDescription": "Set a user's storage quota override in gigabytes.",
  "geoblock_disableTitle": "Disable Geo-Block",
  "geoblock_disableDescription": "Turn off geo-blocking and clear its firewall rules.",
  "network_speedtestTitle": "Network Speedtest",
  "network_speedtestDescription": "Run a download, upload, and latency test against the network test server.",
  "sections": "Command sections"
} as const;
